import "./ContactSection.scss";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Row";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelopeOpenText,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";

import { faLinkedin, faGithubAlt } from "@fortawesome/free-brands-svg-icons";
import MessageForm from "../MessageForm/MessageForm";
// const contactArr = [
//   { title: "LinkedIn", icon: "" },
//   { title: "GitHub", icon: "" },
// ];
export default function ContactSection() {
  return (
    <div className="contact" id="contact">
      <Container>
        {/* <Row xs={1}> */}
        <Row sx={1} sm={1} md={1} lg={2}>
          <Col>
            <div className="contact__wrapper">
              <h2 className="contact__title">Connect with me </h2>
              <ul className="contact__list">
                <li>
                  <a
                    href="https://www.linkedin.com/in/gabriela-terasaka/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faLinkedin}
                      className="contact__icon--social-media"
                    />
                    <span className="contact__description"> LinkedIn</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://github.com/GabrielaTerasaka"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faGithubAlt}
                      className="contact__icon--social-media"
                    />
                    <span className="contact__description"> GitHub</span>
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:gabriela.terasaka@gmail.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      className="contact__icon--social-media"
                    />
                    <span className="contact__description">
                      {" "}
                      gabriela.terasaka@gmail.com
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </Col>
          <Col>
            <div className="contact__wrapper">
              <h2 className="contact__title">
                Leave a Message
                <FontAwesomeIcon
                  icon={faEnvelopeOpenText}
                  className="contact__icon"
                />
              </h2>

              <MessageForm />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
